























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxButton, DxTextBox, DxLookup, DxList } from 'devextreme-vue';
import { DxValidator, DxCustomRule, DxRequiredRule } from 'devextreme-vue/validator';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';   
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import { CountryService } from '@/service/CountryService';
import { InvoiceLineItemService } from '@/service/InvoiceLineItemService';
import { SelectOption } from '@/models/SelectOption';
import { Prop } from 'vue-property-decorator';
import { confirm } from 'devextreme/ui/dialog';       
import { ManualCodeInvoiceLineItemDto } from '@/models/ManualCodeInvoiceLineItemDto';
import DxValidationGroup from 'devextreme-vue/validation-group'
import ValidationGroup from "devextreme/ui/validation_group";
import _ from 'lodash';
import { InvoiceLineItemUpdateCountryDto } from '@/models/InvoiceLineItemUpdateCountryDto';
import * as overlay from 'devextreme/ui/overlay';

@Component({
    components: {
        DxButton,            
        Popup,            
        DxTextBox,            
        DxToolbarItem,
        DxLookup,     
        DxList,      
        DxValidator,
        DxCustomRule,
        DxScrollView,            
        DxValidationGroup,
        DxRequiredRule,
        DxLoadIndicator
    }
})
export default class UpdateLineItemsCountry extends Vue {
    public $refs: Vue['$refs'] & {
        validationGroupRef? : ValidationGroup;
        popup?: Popup;
    } = {};
    
    @Prop({ default: false })
    showDialog!: boolean;        

    @Prop()
    oldCountryCode!: string;

    @Prop()
    selectedRows!: ManualCodeInvoiceLineItemDto[];

    countriesDataSource: SelectOption[] = [];        
    
    updatingCountryCode: boolean = false;
    selectedCountryId: number = 0;   
    selectedCountryCode: string = "";    
    selectedRowsCount: number = 0;
    selectedRowsIds: Array<Guid> = [];            
    lineItemService: InvoiceLineItemService;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {
        this.$emit("hiding", this.selectedRowsIds, this.selectedCountryCode);
    }

    @Watch("showDialog")
    onPropertyChanged(value: boolean, oldValue: boolean) {                
        if (value) {                                                         
            this.selectedRowsCount = this.selectedRows.length;
            this.validationGroup.reset();
        }            
    }   

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }
   
    constructor() {
        super();         
        this.lineItemService = new InvoiceLineItemService();  
        overlay.baseZIndex(2000); 
        this.loadData();       
        
    }        

    async loadData() { 
        let countryService = new CountryService();
        this.countriesDataSource = await countryService.getAllSelectOptions(false);            
    }   

    hidingUpdate() {
        this.showingDialog = false;         
    }

    async confirmSave() {
        if (this.updatingCountryCode) {
            return;
        }

        let validation = this.validationGroup.validate();
        if(!validation.isValid){
            return;
        }        

        var selectedCountryOption = this.countriesDataSource.filter(c => c.value == this.selectedCountryId)[0];            

        if (this.oldCountryCode == selectedCountryOption.text) {
            this.hidingUpdate();
            return;
        }

        let dialogText: string = `Are you sure you want to update the country from ${this.oldCountryCode} 
            to ${selectedCountryOption.text} for the ${this.selectedRowsCount} selected row(s)?`

        var dialogResult = confirm(dialogText, "Update Country");
        dialogResult
        .then(dialogResult => {
            if(dialogResult) {
                this.selectedCountryCode = selectedCountryOption.text;
                this.selectedRowsIds = this.selectedRows.map(li => li.InvoiceLineItemId);
                let updateDto: InvoiceLineItemUpdateCountryDto = {
                    InvoiceLineItemIds: this.selectedRowsIds,
                    CountryId: this.selectedCountryId
                };

                this.updatingCountryCode = true;
                this.lineItemService.updateLineItemCountryCodes(updateDto)
                .then(_ => {
                    this.hidingUpdate();                                                
                })
                .finally( () => {
                    this.updatingCountryCode = false;
                });                              
            }                
        });                     
    }
}
